import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../services/api';

interface ProfileRequiredRouteProps {
  children: React.ReactNode;
}

export const ProfileRequiredRoute: React.FC<ProfileRequiredRouteProps> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [profileLoading, setProfileLoading] = useState(true);
  const [hasProfile, setHasProfile] = useState(false);

  useEffect(() => {
    const checkProfile = async () => {
      if (!user) {
        setProfileLoading(false);
        return;
      }

      try {
        const { data: profileData, error } = await api.profiles.getByUserId(user.id);
        
        if (error) {
          setHasProfile(false);
        } else {
          setHasProfile(!!profileData);
        }
      } catch (err) {
        setHasProfile(false);
      } finally {
        setProfileLoading(false);
      }
    };

    if (!authLoading) {
      checkProfile();
    }
  }, [user, authLoading]);

  // Chargement de l'authentification
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#002c46] mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  // Pas connecté
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Chargement du profil
  if (profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#002c46] mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification du profil...</p>
        </div>
      </div>
    );
  }

  // Pas de profil - rediriger DIRECTEMENT vers création de profil
  if (!hasProfile) {
    return <Navigate to="/create-profile" replace />;
  }

  // Tout est OK, afficher le contenu
  return <>{children}</>;
};
